import type { Dispatch, SetStateAction } from "react";
import { useState } from "react";

interface UseRewardsDestinationResult {
    destination: string;
    setDestination: Dispatch<SetStateAction<string>>;
}

/** Empty selects the source wallet or Squads vault as the default for new positions. */
export function useRewardsDestination(): UseRewardsDestinationResult {
    const [destination, setDestination] = useState("");
    return { destination, setDestination };
}
